import { createSlice } from '@reduxjs/toolkit';

interface ContentSharingState {
  token: string | undefined;
  initialized: boolean;
}

const initialState = {
  token: undefined,
  initialized: false,
} satisfies ContentSharingState as ContentSharingState;

const contentSharingSlice = createSlice({
  name: 'contentSharing',
  initialState,
  reducers: {
    setInitialized(state, action) {
      state.initialized = action.payload.initialized;
    },
    setToken(state, action) {
      state.token = action.payload;
    },
    clearToken(state) {
      return initialState;
    },
  },
  selectors: {
    isInitialized: state => state.initialized,
    getToken: state => state.token,
  },
});

export const { setInitialized, setToken, clearToken } = contentSharingSlice.actions;
export default contentSharingSlice;
